import { ApiRequest } from 'src/models/api.request';
import CevirilecekDovizTutarIstek from 'src/models/GenelTanimlar/CevirilecekDovizTutarIstek';
import GnlDovizkurDTO from 'src/models/GenelTanimlar/GnlDovizkurDTO';
import HastaTestIstemSilModel from 'src/models/GenelTanimlar/HastaTestIstemSilModel';
import VwHastaislemlistDTO from 'src/models/GenelTanimlar/VwHastaIslemDTO';
import MuracaatDetayliAramaRequest from 'src/models/HastaKayit/MuracaatDetayliAramaRequest';
import VwHastaLissonucDurumDTO from 'src/models/HastaKayit/VwHastaLissonucDurumDTO';
import VwHastamuracaatDTO from 'src/models/HastaKayit/VwHastamuracaatDTO';
import VwHastamuracaatListeDTO from 'src/models/HastaKayit/VwHastamuracaatListeDTO';
import VwMuracaatAramaDTO from 'src/models/HastaKayit/VwMuracaatAramaDTO';
import VwHastamuracaatizlemDTO from 'src/models/MuracaatIzlem/VwHastamuracaatizlemDTO';
import api from 'src/services/core/api';
import { TopluSonucGosterRequest } from 'src/store/Slices/KurumDisiHastaKayit/KDHastaKayit';
import { IMuracaaatIzlemSearchType } from 'src/store/Slices/MuracaatIzlem/MuracaatIzlemSlice';
import { helper } from 'src/utils/helper';

export const MuracaatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVwHastamuracaatListeFind: builder.query<
      Array<VwHastamuracaatListeDTO>,
      {
        kimlikId: number;
        // treekey: string,
        bagliOrgId: number;
        iptalGosterme: boolean;
        sadeceBorcuOlan: boolean;
        doktorId?: number;
        atanmisKurumlar?: number[];
        kullanici?: number;
      }
    >({
      query: (request) => {
        var apiRequest: ApiRequest<VwHastamuracaatListeDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              {
                groupOperator: 'or',
                predicates: [
                  { fieldName: 'bagliOrganizasyonId', operator: '=', value1: request.bagliOrgId },
                  { fieldName: 'organizasyonId', operator: '=', value1: request.bagliOrgId }
                ]
              },
              { fieldName: 'kimlikId', operator: '=', value1: request.kimlikId }
            ]
          },
          sorts: [{ fieldName: 'tarih', ascending: false }],
          paging: false
        };
        if (request.doktorId > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'doktorId',
            operator: '=',
            value1: request.doktorId
          });
        }
        if (request.atanmisKurumlar.length > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'kurumId',
            operator: 'in',
            value1: request.atanmisKurumlar
          });
        }
        if (request.iptalGosterme) {
          apiRequest.filters.predicates.push({
            fieldName: 'iptal',
            operator: '=',
            value1: 'H'
          });
        }
        if (request.sadeceBorcuOlan) {
          apiRequest.filters.predicates.push({
            fieldName: 'kalantoplam',
            operator: '>',
            value1: 0
          });
        }
        if (request.kullanici) {
          apiRequest.filters.predicates.push({
            fieldName: 'ekleyenKullanici',
            operator: '=',
            value1: request.kullanici
          });
        }
        return {
          url: 'VwHastamuracaatListeDTO/find',
          method: 'POST',
          body: apiRequest
        };
      },
      providesTags: ['VwHastamuracaatListe']
    }),
    deleteVwHastamuracaat: builder.mutation<boolean, number>({
      query: (id) => ({
        url: 'muracaat/MuracaatDelete/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['VwHastamuracaatListe']
    }),
    addVwHastamuracaat: builder.mutation<VwHastamuracaatDTO, VwHastamuracaatDTO>({
      query: (request) => ({
        url: 'muracaat/MuracaatCreate',
        method: 'POST',
        body: request
      }),
      invalidatesTags: ['VwHastamuracaatListe']
    }),
    updateVwHastamuracaat: builder.mutation<VwHastamuracaatDTO, VwHastamuracaatDTO>({
      query: (request) => ({
        url: 'muracaat/MuracaatUpdate',
        method: 'PUT',
        body: request
      }),
      invalidatesTags: ['VwHastamuracaatListe']
    }),
    updateRefDoktor: builder.mutation<boolean, { muracaatId: number; refDoktorId: number }>({
      query: (request) => ({
        url: 'muracaat/RefDoktorUpdate',
        method: 'PUT',
        params: {
          muracaatId: request.muracaatId,
          refDoktorId: request.refDoktorId
        }
      })
    }),
    getVwHastamuracaatById: builder.query<VwHastamuracaatDTO, number>({
      query: (id) => ({
        url: 'muracaat/GetId',
        method: 'GET',
        params: {
          id
        }
      }),
      keepUnusedDataFor: 0
    }),
    getDetayliMuracaatArama: builder.query<Array<VwMuracaatAramaDTO>, MuracaatDetayliAramaRequest>({
      query: (request) => ({
        url: 'muracaat/DetayliMuracaatArama',
        method: 'POST',
        body: request
      })
    }),
    ayniBransAyniGunPolVarMi: builder.query<
      number,
      {
        kimlikId: number;
        bransId: number;
        kurumId: number;
        orgId: number;
      }
    >({
      query: (request) => ({
        url:
          'muracaat/ayniBransAyniGunPolVarMi/' +
          request.kimlikId +
          '/' +
          request.bransId +
          '/' +
          request.kurumId +
          '/' +
          request.orgId,
        method: 'GET'
      })
    }),
    getVwHastamuracaatIzlemFind: builder.query<Array<VwHastamuracaatizlemDTO>, IMuracaaatIzlemSearchType>({
      query: (request) => {
        var apiRequest: ApiRequest<VwHastamuracaatizlemDTO> = {
          filters: request.islemNo
            ? {
              groupOperator: 'and',
              predicates: [
                {
                  fieldName: 'id',
                  operator: '=',
                  value1: request.islemNo
                }
              ]
            }
            : {
              groupOperator: 'and',
              predicates: [
                {
                  fieldName: 'tarih',
                  operator: '>',
                  value1: request.basTarih
                },
                {
                  fieldName: 'tarih',
                  operator: '<=',
                  value1: request.bitTarih
                }
              ]
            },
          sorts: [{ fieldName: 'tarih', ascending: false }],
          paging: false
        };
        if (request.organizasyonIds?.length > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'organizasyonId',
            operator: 'in',
            value1: request.organizasyonIds.split(',')
          });
        }
        if (request.sadeceBorcuOlan) {
          apiRequest.filters.predicates.push({
            fieldName: 'kalantoplam',
            operator: '>',
            value1: 0
          });
        }
        if (request.sonucuCikanlar) {
          apiRequest.filters.predicates.push({
            fieldName: 'sonucsayi',
            operator: '>',
            value1: 0
          });
        }
        if (request.adi) {
          apiRequest.filters.predicates.push({
            fieldName: 'adi',
            operator: 'like',
            value1: request.adi
          });
        }
        if (request.soyadi) {
          apiRequest.filters.predicates.push({
            fieldName: 'soyadi',
            operator: 'like',
            value1: request.soyadi
          });
        }
        if (request.aileAdi) {
          apiRequest.filters.predicates.push({
            fieldName: 'aileAdi',
            operator: 'like',
            value1: request.aileAdi
          });
        }
        // if (request.islemNo) {
        //     apiRequest.filters.predicates.push({
        //         fieldName: "id",
        //         operator: "=",
        //         value1: request.islemNo
        //     });
        // }
        if (request.kurumIds?.length > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'kurumId',
            operator: 'in',
            value1: request.kurumIds.split(',')
          });
        }
        if (request.refDoktorIds) {
          apiRequest.filters.predicates.push({
            fieldName: 'referansDoktorId',
            operator: 'in',
            value1: request.refDoktorIds.split(',')
          });
        }
        if (request.dogumYil) {
          apiRequest.filters.predicates.push({
            fieldName: 'dogumTarihi',
            operator: 'between',
            value1: request.dogumYil + '-01-01',
            value2: request.dogumYil + '-12-31'
          });
        }
        return {
          url: 'VwHastamuracaatizlemDTO/find',
          method: 'POST',
          body: JSON.stringify(apiRequest)
        };
      },
      providesTags: ['HastaMuracaatIzlem']
    }),
    getVwHastaislemlistDTOFind: builder.query<Array<VwHastaislemlistDTO>, number>({
      query: (request) => {
        var apiRequest: ApiRequest<VwHastaislemlistDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              {
                fieldName: 'muracaatId',
                operator: '=',
                value1: request
              },
              {
                fieldName: 'odemeyontem',
                operator: '<',
                value1: 91
              }
            ]
          },
          sorts: [{ fieldName: 'tarih', ascending: false }],
          paging: false
        };

        return {
          url: 'VwHastaislemlistDTO/find',
          method: 'POST',
          body: apiRequest
        };
      }
    }),
    getVwHastaLissonucDurumFind: builder.query<Array<VwHastaLissonucDurumDTO>, TopluSonucGosterRequest>({
      query: (request) => {
        var apiRequest: ApiRequest<VwHastaLissonucDurumDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              {
                fieldName: 'tarih',
                operator: '>=',
                value1: request.basTarih
              },
              {
                fieldName: 'tarih',
                operator: '<=',
                value1: request.bitTarih
              },
              {
                fieldName: 'doktorId',
                operator: '=',
                value1: request.personelId
              }
            ]
          },
          sorts: [{ fieldName: 'tarih', ascending: false }],
          paging: false
        };
        if (request.hastaAdSoyad !== '') {
          apiRequest.filters.predicates.push({
            fieldName: 'adSoyad',
            operator: 'like',
            value1: helper.UpperCaseAsc(request.hastaAdSoyad)
          });
        }
        if (request.servisId > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'servisId',
            operator: '=',
            value1: request.servisId
          });
        }
        if (request.doktorId > 0) {
          apiRequest.filters.predicates.push({
            fieldName: 'doktorId',
            operator: '=',
            value1: request.doktorId
          });
        }

        return {
          url: 'VwHastaLissonucDurumDTO/find',
          method: 'POST',
          body: apiRequest
        };
      }
    }),
    gecmisGunlerDovizKurGetir: builder.query<boolean, { gunSayisi: number }>({
      query: (request) => ({
        url: 'muracaat/GecmisGunlerDovizKurGetir',
        method: 'GET',
        params: request
      })
    }),
    eksikGunKurKaydet: builder.query<boolean, void>({
      query: () => ({
        url: 'muracaat/EksikGunKurKaydet',
        method: 'GET'
      })
    }),
    GetVwMuracaatText: builder.query<Array<VwMuracaatAramaDTO>, { searchText: string, bagliOrgId: number }>({
      query: (request) => ({
        url: "muracaat/GetVwMuracaatText",
        method: "GET",
        params: request
      })
    }),
    GetMuracaatById: builder.query<VwMuracaatAramaDTO, { id?: number }>({
      query: (request) => ({
        url: "muracaat/GetMuracaatById",
        method: "GET",
        params: request
      })
    }),
    hastalikBilgiGuncelle: builder.mutation<
      boolean,
      { muracaatId: number; hastaliktanimId: number; hastaliktanimtaniId: number }
    >({
      query: (req) => ({
        url: 'muracaat/HastalikBilgiGuncelle',
        method: 'PUT',
        params: req
      })
    }),
    hastaIstemSil: builder.mutation<
      string,
      HastaTestIstemSilModel 
    >({
      query: (req) => ({
        url: 'muracaat/HastaIslemSil',
        method: 'DELETE',
        body: JSON.stringify(req)
      })
    })
    
  })
});

export const {
  useGetVwHastamuracaatListeFindQuery,
  useDeleteVwHastamuracaatMutation,
  useAddVwHastamuracaatMutation,
  useUpdateVwHastamuracaatMutation,
  useGetVwHastamuracaatByIdQuery,
  useGetDetayliMuracaatAramaQuery,
  useLazyAyniBransAyniGunPolVarMiQuery,
  useGetVwHastamuracaatIzlemFindQuery,
  useGetVwHastaislemlistDTOFindQuery,
  useLazyGetVwHastamuracaatByIdQuery,
  useGetVwHastaLissonucDurumFindQuery,
  useUpdateRefDoktorMutation,
  useLazyGecmisGunlerDovizKurGetirQuery,
  useLazyEksikGunKurKaydetQuery,
  useGetVwMuracaatTextQuery, useLazyGetVwMuracaatTextQuery,
  useHastalikBilgiGuncelleMutation,
  useLazyGetMuracaatByIdQuery,
  useHastaIstemSilMutation,
} = MuracaatApi;
